import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import {
  backend,
  commentBackend,
  eventBackend,
  GroupData,
} from "../../services";
import ManShortSelector from "../../components/ui/shortItemSelect";
import { AddUserModalProps, EventFullData, UserShortInfo } from "../../types";
import { useDispatch } from "react-redux";
import { actions } from "../../state/reducer";
import { generateRandomString, hasCommonElement } from "../../utils";
import { RootState } from "../../state/reducer";
import { GroupSelect, ManSelector, Textarea } from "../components";

const CustomerAddUserModal: React.FC<AddUserModalProps> = ({
  event_id,
  onSave,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const State = useSelector((state: RootState) => state);
  const session = State.session;
  const rights = State.rights;
  const [selectedStatus, setSelectedStatus] = useState<number>(2);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null); // Выбранный пользователь
  const groupList = State.groupsToSelect;
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );
  const [comment, setComment] = useState<string | undefined>(); // Комментарий
  const modalRef = useRef<HTMLDivElement>(null); // Ref для модального окна
  const [availableUsers, setAvailableUsers] = useState<UserShortInfo[]>([]);

  useEffect(() => {
    backend
      .getAllUsersShorts({ group_id: selectedGroup })
      .then((res) => {
        setAvailableUsers(res.users);
      })
      .catch((err) => {
        console.log(err);
        toast("Не удалось загрузить список пользователей");
      });
  }, [groupList, selectedGroup]);

  // Обработчик выбора пользователя
  const handleUserSelect = (userId: number) => {
    setSelectedUserId(userId);
  };

  // Закрытие модального окна с сохранением
  const closeWithSave = () => {
    if (!event_id) return;
    if (selectedUserId === null) {
      toast("Выберите пользователя");
      return;
    }
    if (comment) {
      commentBackend
        .addComment({ tab_id: 3, item_id: event_id, comment })
        .catch(() => {
          toast("Ошибка добавления комментария");
        });
    }
    backend
      .addCustomerUser({
        customerid: event_id,
        userid: selectedUserId,
        roleid: 2,
      })
      .then((res) => {
        const data = res.updatedCustomerData;
        if (data) {
          const newResponsibleId = data.users?.find(
            (user) => user.role_id === 2
          );
          if (newResponsibleId && newResponsibleId?.user_id !== session?.id) {
            toast("Клиент передан другому пользователю");
            /* if (rights.rang > 2 && !hasCommonElement(rights.permissions, [10, 11]))
          setTimeout(() => {
            document.location.pathname = "/clients/1";
          }, 2000) */
          } else {
            toast("Данные обновлены");
          }
          dispatch(actions.customerDisplayData(data));
          onSave(data);
        } else {
          toast("Не удалось получить обновленные данные");
        }
      })
      .catch((e) => {
        const data = e.updatedCustomerData;
        if (!data) {
          toast("Ошибка добавления данных");
        } else {
          toast("Это не ошибка!");
          dispatch(actions.customerDisplayData(data));
        }
      }); // Вызываем коллбэк с выбранным ID пользователя
    closeModal(); // Закрываем модальное окно
  };

  // Обработчик клика за пределами модального окна
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        closeModal(); // Закрываем модальное окно
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModal]);

  // (event) =>  setSelectedGroup(Number(event.target.value))

  return (
    <div className="editModal" ref={modalRef}>
      <div className="modalHeading">
        <h3>Назначить ответственного</h3>
      </div>
      <div className="columnCenter creationForm">
        {rights.rang < 3 && (
          <GroupSelect
            label="Группа"
            groups={groupList}
            value={selectedGroup}
            onChange={setSelectedGroup}
          />
        )}
        <ManSelector
          label="Ответственный"
          users={[{ id: 0, name: "Свободно" }, ...availableUsers]}
          selectedUserId={selectedUserId || 0}
          onChange={handleUserSelect}
        />

        <Textarea
          label="Комментарий"
          value={comment}
          onChange={(event) => setComment(event.target.value)}
        />
      </div>
      <div className="flex between btnRow">
        <button className="filterButton" type="button" onClick={closeWithSave}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default CustomerAddUserModal;
